// import { useNavigate } from "react-router-dom";
// import { FileText, ArrowRight } from "lucide-react";
// import quotationsData from "../data/quotationsData";

// function money(n) {
//     return `₹${n.toLocaleString("en-IN")}`;
// }

// export default function MyEnquiries() {
//     const navigate = useNavigate();

//     return (
//         <div>
//             <h1 className="text-3xl font-extrabold text-gray-900">My Enquiries</h1>
//             <p className="text-gray-500 mt-1 mb-6">
//                 All open prototype enquiries you have published
//             </p>

//             <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-5">
//                 {quotationsData.map((q) => (
//                     <div
//                         key={q.id}
//                         className="rounded-xl border bg-card text-card-foreground shadow p-5 hover:shadow-elevated transition"
//                     >
//                         {/* Top row: ID + status */}
//                         <div className="flex items-center justify-between mb-4">
//                             <span className="text-xs font-mono font-medium px-2.5 py-1 rounded-lg bg-gray-50 border border-gray-200 text-gray-600">
//                                 {q.id}
//                             </span>
//                             <span className="text-xs font-semibold px-3 py-1 rounded-full bg-indigo-50 text-indigo-600 border border-indigo-100">
//                                 {q.status}
//                             </span>
//                         </div>

//                         {/* Title + description */}
//                         <h2 className="font-bold text-gray-900 text-lg mb-1">{q.title}</h2>
//                         <p className="text-sm text-gray-500 mb-4">{q.description}</p>

//                         {/* Spec chips */}
//                         <div className="flex flex-wrap gap-1 mb-5">
//                             <span className="text-xs font-medium px-2 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
//                                 {q.category}
//                             </span>
//                             <span className="text-xs font-medium px-2 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
//                                 {money(q.budgetMin)} – {money(q.budgetMax)}
//                             </span>
//                             <span className="text-xs font-medium px-2 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
//                                 {q.targetDate}
//                             </span>
//                         </div>

//                         {/* Footer: quotations count + open button */}
//                         <div className="flex items-center justify-between border-t border-gray-100 pt-4">
//                             <span className="flex items-center gap-1.5 text-sm text-gray-600">
//                                 <FileText className="w-4 h-4 text-blue-500" />
//                                 {q.quotes.length} quotation{q.quotes.length === 1 ? "" : "s"}
//                             </span>
//                             <button
//                                 type="button"
//                                 onClick={() => navigate(`/app/quotations/${q.id}`)}
//                                 className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground h-8 rounded-md px-3 text-xs"
//                             >
//                                 Open
//                                 <ArrowRight className="w-4 h-4" />
//                             </button>
//                         </div>
//                     </div>
//                 ))}
//             </div>

//             {quotationsData.length === 0 && (
//                 <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
//                     You haven't published any enquiries yet.
//                 </div>
//             )}

//         </div>
//     );
// }






// // import { useState, useEffect } from "react";
// // import { useNavigate } from "react-router-dom";
// // import { FileText, ArrowRight, Loader2 } from "lucide-react";
// // import enquiryService from "../service/enquiryService";

// // function money(n) {
// //   return `₹${n.toLocaleString("en-IN")}`;
// // }

// // // Status color mapping
// // const statusColors = {
// //   DRAFT: "bg-gray-100 text-gray-600",
// //   PUBLISHED: "bg-blue-50 text-blue-700",
// //   QUOTATIONS_RECEIVED: "bg-indigo-50 text-indigo-700",
// //   UNDER_EVALUATION: "bg-amber-50 text-amber-700",
// //   QUOTATION_SELECTED: "bg-emerald-50 text-emerald-700",
// //   WORK_ORDER_INITIATED: "bg-emerald-50 text-emerald-700",
// //   IN_DEVELOPMENT: "bg-emerald-50 text-emerald-700",
// //   COMPLETED: "bg-gray-100 text-gray-600",
// // };

// // // Format status for display
// // const formatStatus = (status) => {
// //   if (!status) return "Draft";
// //   return status
// //     .split("_")
// //     .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
// //     .join(" ");
// // };

// // // Format budget range
// // const formatBudgetRange = (budget) => {
// //   if (!budget) return "Budget TBD";

// //   const budgetMap = {
// //     "BELOW_50000": "Below ₹50,000",
// //     "BETWEEN_50000_AND_100000": "₹50,000 – ₹1,00,000",
// //     "BETWEEN_100000_AND_500000": "₹1,00,000 – ₹5,00,000",
// //     "ABOVE_500000": "Above ₹5,00,000",
// //   };

// //   return budgetMap[budget] || budget;
// // };

// // export default function MyEnquiries() {
// //   const navigate = useNavigate();
// //   const [enquiries, setEnquiries] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");

// //   // Get userId from localStorage
// //   const userId = localStorage.getItem('userId');

// //   useEffect(() => {
// //     if (!userId) {
// //       setError("User not logged in. Please login again.");
// //       setLoading(false);
// //       return;
// //     }
// //     fetchEnquiries();
// //   }, [userId]);

// //   const fetchEnquiries = async () => {
// //     setLoading(true);
// //     setError("");

// //     try {
// //       const response = await enquiryService.getEnquiriesByUser(userId);

// //       if (response.success && response.data) {
// //         const enquiriesData = Array.isArray(response.data) ? response.data : 
// //                              (response.data?.content || response.data?.enquiries || []);
// //         setEnquiries(enquiriesData);
// //       } else if (Array.isArray(response)) {
// //         setEnquiries(response);
// //       } else {
// //         setEnquiries([]);
// //         setError(response.message || "No enquiries found.");
// //       }
// //     } catch (err) {
// //       console.error("Error fetching enquiries:", err);
// //       setError(err.message || "Failed to load enquiries. Please try again.");
// //       setEnquiries([]);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   if (loading) {
// //     return (
// //       <div className="flex items-center justify-center h-64">
// //         <Loader2 className="w-8 h-8 text-indigo-600 animate-spin" />
// //         <span className="ml-3 text-gray-600">Loading your enquiries...</span>
// //       </div>
// //     );
// //   }

// //   if (error) {
// //     return (
// //       <div>
// //         <h1 className="text-3xl font-extrabold text-gray-900">My Enquiries</h1>
// //         <p className="text-gray-500 mt-1 mb-6">
// //           All open prototype enquiries you have published
// //         </p>
// //         <div className="h-40 flex items-center justify-center text-red-500 border border-red-200 bg-red-50 rounded-2xl">
// //           {error}
// //         </div>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div>
// //       <h1 className="text-3xl font-extrabold text-gray-900">My Enquiries</h1>
// //       <p className="text-gray-500 mt-1 mb-6">
// //         {enquiries.length} open prototype {enquiries.length === 1 ? "enquiry" : "enquiries"} you have published
// //       </p>

// //       <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-5">
// //         {enquiries.map((q) => (
// //           <div
// //             key={q.id || q.enquiryId}
// //             className="rounded-xl border bg-card text-card-foreground shadow p-5 hover:shadow-elevated transition"
// //           >
// //             {/* Top row: Enquiry ID + Development Stage */}
// //             <div className="flex items-center justify-between mb-4">
// //               <span className="text-xs font-mono font-medium px-2.5 py-1 rounded-lg bg-gray-50 border border-gray-200 text-gray-600">
// //                 {q.id || q.enquiryId || "N/A"}
// //               </span>
// //               <span className={`text-xs font-semibold px-3 py-1 rounded-full border ${
// //                 statusColors[q.status] || "bg-gray-100 text-gray-600"
// //               }`}>
// //                 {formatStatus(q.status)}
// //               </span>
// //             </div>

// //             {/* Title + description */}
// //             <h2 className="font-bold text-gray-900 text-lg mb-1">{q.projectName || "Untitled"}</h2>
// //             <p className="text-sm text-gray-500 line-clamp-2 mb-4">
// //               {q.shortDescription || q.detailedProjectDescription || "No description provided"}
// //             </p>

// //             {/* Spec chips */}
// //             <div className="flex flex-wrap gap-1 mb-5">
// //               <span className="text-xs font-medium px-2 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
// //                 {q.productCategory || q.category || "General"}
// //               </span>
// //               <span className="text-xs font-medium px-2 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
// //                 {formatBudgetRange(q.expectedBudgetRange)}
// //               </span>
// //               <span className="text-xs font-medium px-2 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
// //                 {q.targetDeliveryDate || "Date TBD"}
// //               </span>
// //             </div>

// //             {/* Footer: quotations count + open button */}
// //             <div className="flex items-center justify-between border-t border-gray-100 pt-4">
// //               <span className="flex items-center gap-1.5 text-sm text-gray-600">
// //                 <FileText className="w-4 h-4 text-blue-500" />
// //                 {q.quotationsCount || q.quotes?.length || 0} quotation{(q.quotationsCount || q.quotes?.length || 0) === 1 ? "" : "s"}
// //               </span>
// //               <button
// //                 type="button"
// //                 onClick={() => navigate(`/app/quotations/${q.id || q.enquiryId}`)}
// //                 className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground h-8 rounded-md px-3 text-xs"
// //               >
// //                 Open
// //                 <ArrowRight className="w-4 h-4" />
// //               </button>
// //             </div>
// //           </div>
// //         ))}
// //       </div>

// //       {enquiries.length === 0 && (
// //         <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
// //           You haven't published any enquiries yet.
// //         </div>
// //       )}
// //     </div>
// //   );
// // }



import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileText, ArrowRight, Search, SlidersHorizontal, X, Calendar as CalendarIcon } from "lucide-react";
import quotationsData from "../data/quotationsData";

function money(n) {
    return `₹${n.toLocaleString("en-IN")}`;
}

const statusFilters = ["All", "Draft", "Published", "Quotations Received", "Under Evaluation", "Quotation Selected", "Work Order Initiated", "In Development", "Completed"];

const dateFilters = [
    { id: "all", label: "All Dates" },
    { id: "today", label: "Today" },
    { id: "yesterday", label: "Yesterday" },
    { id: "last7days", label: "Last 7 Days" },
    { id: "thisMonth", label: "This Month" },
    { id: "custom", label: "Custom Date" },
];

export default function MyEnquiries() {
    const navigate = useNavigate();
    const [query, setQuery] = useState("");
    const [activeStatusFilter, setActiveStatusFilter] = useState("All");
    const [activeDateFilter, setActiveDateFilter] = useState("all");
    const [customDate, setCustomDate] = useState("");
    const [showStatusDropdown, setShowStatusDropdown] = useState(false);
    const [showDateDropdown, setShowDateDropdown] = useState(false);
    const [showCustomDatePopup, setShowCustomDatePopup] = useState(false);

    // Date filter logic
    const filterByDate = (targetDate) => {
        if (!targetDate) return true;

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const dateObj = new Date(targetDate);
        dateObj.setHours(0, 0, 0, 0);

        switch (activeDateFilter) {
            case "all":
                return true;
            case "today":
                return dateObj.getTime() === today.getTime();
            case "yesterday": {
                const yesterday = new Date(today);
                yesterday.setDate(yesterday.getDate() - 1);
                return dateObj.getTime() === yesterday.getTime();
            }
            case "last7days": {
                const last7Days = new Date(today);
                last7Days.setDate(last7Days.getDate() - 7);
                return dateObj >= last7Days && dateObj <= today;
            }
            case "thisMonth": {
                const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
                return dateObj >= firstDayOfMonth && dateObj <= today;
            }
            case "custom": {
                if (!customDate) return true;
                const customDateObj = new Date(customDate);
                customDateObj.setHours(0, 0, 0, 0);
                return dateObj.getTime() === customDateObj.getTime();
            }
            default:
                return true;
        }
    };

    const filtered = quotationsData.filter((q) => {
        const matchesStatus = activeStatusFilter === "All" || q.status === activeStatusFilter;
        const matchesQuery =
            q.title?.toLowerCase().includes(query.toLowerCase()) ||
            q.id?.toLowerCase().includes(query.toLowerCase()) ||
            q.category?.toLowerCase().includes(query.toLowerCase());
        const matchesDate = filterByDate(q.targetDate);
        return matchesStatus && matchesQuery && matchesDate;
    });

    const getStatusLabel = () => {
        return activeStatusFilter === "All" ? "All Status" : activeStatusFilter;
    };

    const getDateLabel = () => {
        const found = dateFilters.find(f => f.id === activeDateFilter);
        return found ? found.label : "All Dates";
    };

    const activeFilterCount = (activeStatusFilter !== "All" ? 1 : 0) + (activeDateFilter !== "all" ? 1 : 0);

    return (
        <div>
            <h1 className="text-3xl font-extrabold text-gray-900">My Enquiries</h1>
            <p className="text-gray-500 mt-1 mb-6">
                All open prototype enquiries you have published
            </p>

            {/* Search + Filters */}
            <div className="bg-white border border-gray-100 rounded-2xl p-4 mb-6">
                <div className="flex flex-wrap items-center gap-3" style={{display:"flex", justifyContent:"space-between"}}>
                    {/* Search */}
                    <div className="flex-1 min-w-[160px] max-w-[280px] flex items-center gap-2 border border-gray-200 rounded-xl px-3 py-2">
                        <Search className="w-4 h-4 text-gray-400" />
                        <input
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            placeholder="Search enquiries..."
                            className="w-full bg-transparent text-sm focus:outline-none"
                        />
                    </div>

                    <div style={{display:"Flex", gap:"10px"}}>
                        {/* Status Dropdown */}
                        <div className="relative">
                            <button
                                onClick={() => {
                                    setShowStatusDropdown(!showStatusDropdown);
                                    if (showDateDropdown) setShowDateDropdown(false);
                                }}
                                className="flex items-center gap-2 px-4 py-2 rounded-xl border border-gray-200 bg-white text-sm font-medium text-gray-700 hover:border-indigo-300 transition whitespace-nowrap"
                            >
                                <SlidersHorizontal className="w-4 h-4" />
                                {getStatusLabel()}
                                <span className={`w-4 h-4 transition-transform ${showStatusDropdown ? "rotate-180" : ""}`}>▾</span>
                            </button>
                            {showStatusDropdown && (
                                <div className="absolute top-full left-0 mt-1 bg-white border border-gray-200 rounded-xl shadow-lg z-10 overflow-hidden max-h-60 overflow-y-auto">
                                    {statusFilters.map((filter) => (
                                        <button
                                            key={filter}
                                            onClick={() => {
                                                setActiveStatusFilter(filter);
                                                setShowStatusDropdown(false);
                                            }}
                                            className={`w-full text-left px-4 py-2.5 text-sm hover:bg-gray-50 transition ${activeStatusFilter === filter ? "bg-indigo-50 text-indigo-600" : "text-gray-700"
                                                }`}
                                        >
                                            {filter}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Date Dropdown */}
                        <div className="relative">
                            <button
                                onClick={() => {
                                    setShowDateDropdown(!showDateDropdown);
                                    if (showStatusDropdown) setShowStatusDropdown(false);
                                }}
                                className="flex items-center gap-2 px-4 py-2 rounded-xl border border-gray-200 bg-white text-sm font-medium text-gray-700 hover:border-indigo-300 transition whitespace-nowrap"
                            >
                                <CalendarIcon className="w-4 h-4" />
                                {getDateLabel()}
                                <span className={`w-4 h-4 transition-transform ${showDateDropdown ? "rotate-180" : ""}`}>▾</span>
                            </button>
                            {showDateDropdown && (
                                <div className="absolute top-full left-0 mt-1 bg-white border border-gray-200 rounded-xl shadow-lg z-10 overflow-hidden">
                                    {dateFilters.map((filter) => (
                                        <button
                                            key={filter.id}
                                            onClick={() => {
                                                if (filter.id === "custom") {
                                                    setShowCustomDatePopup(true);
                                                    setShowDateDropdown(false);
                                                    return;
                                                }
                                                setActiveDateFilter(filter.id);
                                                setCustomDate("");
                                                setShowDateDropdown(false);
                                            }}
                                            className={`w-full text-left px-4 py-2.5 text-sm hover:bg-gray-50 transition ${activeDateFilter === filter.id ? "bg-indigo-50 text-indigo-600" : "text-gray-700"
                                                }`}
                                        >
                                            {filter.label}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                    {/* Active filters count */}
                    {activeFilterCount > 0 && (
                        <span className="text-xs bg-indigo-100 text-indigo-700 px-2 py-1 rounded-full">
                            {activeFilterCount} filter{activeFilterCount > 1 ? "s" : ""} active
                        </span>
                    )}
                </div>
            </div>

            {/* Custom Date Popup */}
            {showCustomDatePopup && (
                <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
                    <div className="bg-white rounded-2xl p-6 max-w-sm w-full mx-4 shadow-2xl">
                        <div className="flex items-center justify-between mb-4">
                            <h3 className="text-lg font-bold text-gray-900">Select Date</h3>
                            <button
                                onClick={() => setShowCustomDatePopup(false)}
                                className="text-gray-400 hover:text-gray-600"
                            >
                                <X className="w-5 h-5" />
                            </button>
                        </div>
                        <input
                            type="date"
                            value={customDate}
                            onChange={(e) => setCustomDate(e.target.value)}
                            className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        <div className="flex gap-3 mt-4">
                            <button
                                onClick={() => setShowCustomDatePopup(false)}
                                className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-700 hover:bg-gray-50"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => {
                                    if (customDate) {
                                        setActiveDateFilter("custom");
                                        setShowCustomDatePopup(false);
                                    }
                                }}
                                className="flex-1 px-4 py-2.5 rounded-xl bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700"
                            >
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Enquiries Grid */}
            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-5">
                {filtered.map((q) => (
                    <div
                        key={q.id}
                        className="rounded-xl border bg-card text-card-foreground shadow p-5 hover:shadow-elevated transition"
                    >
                        <div className="flex items-center justify-between mb-4">
                            <span className="text-xs font-mono font-medium px-2.5 py-1 rounded-lg bg-gray-50 border border-gray-200 text-gray-600">
                                {q.id}
                            </span>
                            <span className="text-xs font-semibold px-3 py-1 rounded-full bg-indigo-50 text-indigo-600 border border-indigo-100">
                                {q.status}
                            </span>
                        </div>

                        <h2 className="font-bold text-gray-900 text-lg mb-1">{q.title}</h2>
                        <p className="text-sm text-gray-500 mb-4">{q.description}</p>

                        <div className="flex flex-wrap gap-1 mb-5">
                            <span className="text-xs font-medium px-2 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
                                {q.category}
                            </span>
                            <span className="text-xs font-medium px-2 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
                                {money(q.budgetMin)} – {money(q.budgetMax)}
                            </span>
                            <span className="text-xs font-medium px-2 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
                                {q.targetDate}
                            </span>
                        </div>

                        <div className="flex items-center justify-between border-t border-gray-100 pt-4">
                            <span className="flex items-center gap-1.5 text-sm text-gray-600">
                                <FileText className="w-4 h-4 text-blue-500" />
                                {q.quotes.length} quotation{q.quotes.length === 1 ? "" : "s"}
                            </span>
                            <button
                                type="button"
                                onClick={() => navigate(`/app/quotations/${q.id}`)}
                                className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground h-8 rounded-md px-3 text-xs"
                            >
                                Open
                                <ArrowRight className="w-4 h-4" />
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {filtered.length === 0 && (
                <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
                    No enquiries match your filters.
                </div>
            )}
        </div>
    );
}